export default __webpack_public_path__ + "static/media/reaction-strategy.5f97d0dd.svg";